import { render, staticRenderFns } from "./ArchiveTabRequests.vue?vue&type=template&id=bf7a794a"
import script from "./ArchiveTabRequests.vue?vue&type=script&lang=js"
export * from "./ArchiveTabRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports